<div id="canton" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg" fxLayout="row" fxLayoutAlign="space-between center">

      <!-- APP TITLE -->
      <div fxLayout="row" fxLayoutAlign="start center">

        <button class="mr-0 mr-sm-16" mat-icon-button (click)="back()">
          <mat-icon>arrow_back</mat-icon>
        </button>

        <div class="product-image mr-8 mr-sm-16" *fuseIfOnDom>
          <img [src]="'assets/images/ecommerce/product-image-placeholder.png'">
        </div>

        <div fxLayout="column" fxLayoutAlign="start start"
          *fuseIfOnDom>
          <div class="h2">
            {{'main.marketplace' | translate}}
          </div>
          <div class="subtitle secondary-text">
            @if (!id) {
              <span>{{'marketplaces.add_new' | translate}}</span>
            }
            @if (id) {
              <span>{{'marketplaces.marketplace_detail' | translate}}</span>
            }
          </div>
        </div>
      </div>
      <!-- / APP TITLE -->

      <div>
        <button mat-raised-button
          class="save-product-button mat-white-bg mt-16 mt-sm-0"
          [disabled]="form.invalid || !selectedPlatforms.length"
          (click)="addMarketPlace(true)">
          @if (!id) {
            <span>{{'main.add' | translate}}</span>
          }
          @if (id) {
            <span>{{'main.save' | translate}}</span>
          }
        </button>
        @if (id) {
          <button mat-raised-button
            class="save-product-button mat-white-bg mt-16 mt-sm-0"
            (click)="deleteMarketplace()">
            <span>{{ 'main.delete' | translate }}</span>
          </button>
        }
      </div>

    </div>
    <!-- / HEADER -->

    <!-- CONTENT CARD -->
    <div class="content-card mat-white-bg">

      <!-- CONTENT -->
      <div class="content">
        <mat-expansion-panel [expanded]="true" (expandedChange)="infoTabOpen = $event"
          [ngStyle]="{'padding-bottom': infoTabOpen ? '30px' : '0px'}">
          <mat-expansion-panel-header [ngClass]="{'openHeader': infoTabOpen}">
            <mat-panel-title>{{ 'event.main_info' | translate }}</mat-panel-title>
            <mat-panel-description>
              {{ 'event.type_main_info' | translate }}
            </mat-panel-description>
          </mat-expansion-panel-header>
          <form [formGroup]="form">
            <mat-form-field class="width-100">
              <mat-label>{{ 'marketplaces.marketplace_title' | translate }}</mat-label>
              <input formControlName="title" matInput required>
            </mat-form-field>
            <mat-form-field class="width-100">
              <mat-label>{{ 'marketplaces.marketplace_category' | translate}}</mat-label>
              <mat-select formControlName="category" multiple>
                @for (mc of marketplaceCategories; track mc) {
                  <mat-option class="category" [value]="mc.id" (click)="selectCat(mc.id, $event)">{{mc.name}}</mat-option>
                  @for (mcsub of mc.marketplaceSubcategory; track mcsub) {
                    <mat-option class="sub-category" [value]="mcsub.id + '_sub'">{{mcsub.name}}</mat-option>
                  }
                }
              </mat-select>
            </mat-form-field>
            @if (form.get('countryId')?.enabled) {
              <mat-form-field appearance="fill" class="width-33">
                <mat-label>{{ 'event.country' | translate }}</mat-label>
                <mat-select formControlName="countryId">
                  @for (country of countries; track country.id) {
                    <mat-option [value]="country.id">
                      {{country.name}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            @if (form.get('cityId')?.enabled) {
              <mat-form-field appearance="fill" class="width-33">
                <mat-label>{{ 'event.canton' | translate }}</mat-label>
                <mat-select formControlName="cityId">
                  @for (city of cities; track city) {
                    <mat-option [value]="city.id">
                      {{city.name}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            @if (form.get('organizationId')?.enabled) {
              <mat-form-field appearance="fill" class="width-33">
                <mat-label>{{ 'event.organization' | translate }}</mat-label>
                <mat-select formControlName="organizationId">
                  @for (org of organizations; track org.id) {
                    <mat-option [value]="org.id">
                      {{org.name}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            <mat-form-field class="width-33">
              <mat-label>{{ 'marketplaces.user_type' | translate}}</mat-label>
              <mat-select formControlName="authorType">
                <mat-option [value]="'front'">{{ 'marketplaces.front_user' | translate}}</mat-option>
                <mat-option [value]="'back'">{{ 'marketplaces.administrator' | translate}}</mat-option>
              </mat-select>
            </mat-form-field>
            <span [matTooltip]="'marketplaces.author_disabled_error' | translate"
              [matTooltipDisabled]="form.get('authorId')?.enabled">
              <mat-form-field class="width-33">
                <mat-label>{{ 'marketplaces.author' | translate}}</mat-label>
                <input type="text"
                  matInput
                  formControlName="authorId"
                  [matAutocomplete]="auto">
                  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                    @for (option of filteredOptions | async; track option) {
                      <mat-option [value]="option">
                        {{option.firstName}} {{option.lastName}}
                      </mat-option>
                    }
                  </mat-autocomplete>
                </mat-form-field>
              </span>
              <mat-form-field class="width-33">
                <mat-label>{{ 'marketplaces.type' | translate}}</mat-label>
                <mat-select formControlName="type">
                  <mat-option [value]="'offer'">{{ 'marketplaces.i_offer' | translate}}</mat-option>
                  <mat-option [value]="'search'">{{ 'marketplaces.i_search' | translate}}</mat-option>
                </mat-select>
              </mat-form-field>
              <div class="quill-description">
                <div class="quill-title">{{ 'marketplaces.information' | translate }}</div>
                <quill-editor formControlName="information"></quill-editor>
              </div>
              <mat-form-field class="width-50">
                <mat-label>{{ 'marketplaces.status' | translate}}</mat-label>
                <mat-select formControlName="status">
                  <mat-option [value]="'activated'">{{ 'marketplaces.activated' | translate}}</mat-option>
                  <mat-option [value]="'notActivated'">{{ 'marketplaces.notActivated' | translate}}</mat-option>
                  <mat-option [value]="'blocked'">{{ 'marketplaces.blocked' | translate}}</mat-option>
                </mat-select>
              </mat-form-field>
              @if (platforms && platforms.length && platforms.length > 1) {
                <mat-form-field class="width-50">
                  <mat-label>{{ 'event.platforms' | translate}}</mat-label>
                  <mat-select  multiple (selectionChange)="changePlatforms($event)"
                    [value]="selectedPlatforms" required>
                    @for (plat of platforms; track plat.id) {
                      <mat-option [value]="plat.id">
                        {{plat.title}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
            <!--          </div>-->
          </form>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="true" (expandedChange)="mediaTabOpen = $event"
                             [ngStyle]="{'padding-bottom': mediaTabOpen ? '30px' : '0px'}">
          <mat-expansion-panel-header [ngClass]="{'openHeader': mediaTabOpen}">
            <mat-panel-title>{{ 'marketplaces.contacts' | translate}}</mat-panel-title>
            <mat-panel-description>
              {{ 'marketplaces.contact_info' | translate }}
              <mat-icon>contact_phone</mat-icon>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div [formGroup]="form">
            <mat-form-field class="width-50">
              <mat-label>{{ 'user.email' | translate }}</mat-label>
              <input formControlName="email" matInput>
            </mat-form-field>
            <mat-form-field class="width-50">
              <mat-label>{{ 'user.phone' | translate }}</mat-label>
              <input formControlName="phone" matInput appPhoneMask>
            </mat-form-field>
          </div>
        </mat-expansion-panel>



          <mat-expansion-panel [expanded]="true" (expandedChange)="mediaTabOpen = $event"
          [ngStyle]="{'padding-bottom': mediaTabOpen ? '30px' : '0px'}">
            <mat-expansion-panel-header [ngClass]="{'openHeader': mediaTabOpen}">
              <mat-panel-title>{{ 'media' | translate }}</mat-panel-title>
              <mat-panel-description>
                {{ 'document_upload' | translate }}
                <mat-icon>insert_drive_file</mat-icon>
              </mat-panel-description>
            </mat-expansion-panel-header>

          <mat-card appearance="outlined" class="margin">
            <mat-card-header>
              <mat-card-title>
                <div class="subtitle">{{ 'picture_upload' | translate }}</div>
              </mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <document-uploader [uploadedFiles]="uploadedPictures" (loadFiles)="uploadPictures($event)"
              [picturePreview]="true" [cropBeforeLoad]="true"></document-uploader>
            </mat-card-content>
          </mat-card>

<!--          <br>-->

<!--            <mat-card appearance="outlined" class="margin">-->
<!--              <mat-card-header>-->
<!--                <mat-card-title>-->
<!--                  <div class="subtitle">{{ 'video_upload' | translate }}</div>-->
<!--                </mat-card-title>-->
<!--              </mat-card-header>-->
<!--              <mat-card-content>-->
<!--                <file-uploader [type]="'marketplace'" [uploadedFiles]="uploadedVideos" (loadedFiles)="uploadVideo($event)"></file-uploader>-->
<!--              </mat-card-content>-->
<!--            </mat-card>-->

<!--            <br>-->

<!--              <mat-card appearance="outlined" class="margin">-->
<!--                <mat-card-header>-->
<!--                  <mat-card-title>-->
<!--                    <div class="subtitle">{{ 'document_upload' | translate }}</div>-->
<!--                  </mat-card-title>-->
<!--                </mat-card-header>-->
<!--                <mat-card-content>-->
<!--                  <document-uploader [uploadedFiles]="uploadedDocuments"-->
<!--                  (loadFiles)="uploadDocuments($event)"></document-uploader>-->
<!--                </mat-card-content>-->
<!--              </mat-card>-->
            </mat-expansion-panel>

          </div>
          <!-- / CONTENT -->

        </div>
        <!-- / CONTENT CARD -->

      </div>
      <!-- / CENTER -->
    </div>

